import type { IMarketplaceAssistant, IPublishAssistantParams } from "../types";
import type { ApiClient } from "./client";

// NOTE: NSAI-3830 — organization-wide assistant marketplace. Publishing is
// gated server-side by marketplace_assistant:write; browsing by
// marketplace_assistant:read. All routes are scoped to the current project via
// the x-project-uuid header the ApiClient already sends.
export class AssistantMarketplaceApi {
  constructor(private readonly apiClient: ApiClient) {}

  async getMarketplaceAssistants(): Promise<IMarketplaceAssistant[]> {
    const response = await this.apiClient.get<IMarketplaceAssistant[]>(
      "/assistant-marketplace",
    );
    return response.data;
  }

  async publish({
    assistantUuid,
    data,
  }: IPublishAssistantParams): Promise<IMarketplaceAssistant> {
    const response = await this.apiClient.post<IMarketplaceAssistant>(
      `/assistant-marketplace/${assistantUuid}`,
      data,
    );
    return response.data;
  }

  async updateListing({
    assistantUuid,
    data,
  }: IPublishAssistantParams): Promise<IMarketplaceAssistant> {
    const response = await this.apiClient.put<IMarketplaceAssistant>(
      `/assistant-marketplace/${assistantUuid}`,
      data,
    );
    return response.data;
  }

  async unpublish(assistantUuid: string): Promise<void> {
    await this.apiClient.delete(`/assistant-marketplace/${assistantUuid}`);
  }
}
